import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_AGENTS'),
  ...asyncTypes('CREATE_AGENTS')
};

export default TYPES;
